module.exports = __webpack_public_path__ + "img/3.d6a43238.jpg";